/*global Phaser*/
class Arrow extends Phaser.GameObjects.Graphics{
    constructor(scene, x, y){
        super(scene, x, y);
    }
    
}

export default Arrow;


//////////////////
// WEBPACK FOOTER
// ./src/ui/Arrow.js
// module id = 5
// module chunks = 0